import { ISeriesPrimitiveAxisView } from 'lightweight-charts'
import type DrawingBase from './drawing.base'
import { LabelAxisPoints } from './drawing.interface'

export type DrawingAxisLabelViewOptions = {
    id: string,
    configId: string,
    point: LabelAxisPoints,
    drawing: DrawingBase<any, any, any>,
    horizontal: boolean
}

class DrawingAxisLabelView implements ISeriesPrimitiveAxisView {
    id: string
    configId: string
    drawing: DrawingBase<any, any, any>
    horizontal: boolean
    point: DrawingAxisLabelViewOptions['point']

    constructor(options: DrawingAxisLabelViewOptions) {
        this.id = options.id
        this.configId = options.configId
        this.drawing = options.drawing
        this.horizontal = options.horizontal
        this.point = options.point
    }

    coordinate(): number {
        const config = this.drawing.getPaneAxisViewConfig(this.configId)
        const point = config[this.point]
        if (this.horizontal) {
            return this.drawing.timeToCoordinate(point) || -10000 // move it out of viewport
        }
        return this.drawing.priceToCoordinate(point) || -100000 // move it out of viewport
    }

    text(): string {
        const config = this.drawing.getPaneAxisViewConfig(this.configId)
        const point = config[this.point]
        if (this.horizontal) {
            return this.drawing.formatTime(point)
        } else {
            return this.drawing.formatPrice(point)
        }
    }

    textColor(): string {
        return '#fff'
    }

    backColor(): string {
        const config = this.drawing.getPaneAxisViewConfig(this.configId)
        return config.labelColors[this.point]
    }

}


export default DrawingAxisLabelView